var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var template = "\n  <div class=\"expansible\">\n    <slot name=\"header\" />\n\n    <div ref=\"content\" class=\"expansible__content\">\n      <div>\n        <template v-if=\"collection.items && !collection.isEmpty()\">\n          <slot name=\"notEmpty\" />\n        </template>\n      </div>\n\n      <await\n        spinner=\"none\"\n        :name=\"spinner\"\n        class=\"await__spinner--screen-light\"\n      />\n    </div>\n\n    <div ref=\"bottom\">\n      <await :name=\"spinner\" spinnerPadding=\"22.5px\">\n        <transition name=\"fade\" mode=\"out-in\">\n          <div v-if=\"collection.items && collection.isEmpty()\" :key=\"1\">\n            <slot name=\"empty\" />\n          </div>\n\n          <div v-else-if=\"!collection.isLastPage\" :key=\"2\">\n            <slot name=\"expand\" :expandEvent=\"expand\" />\n          </div>\n        </transition>\n      </await>\n    </div>\n  </div>\n";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ResizeSensor } from 'css-element-queries';
import { ExpansibleCollection } from '@simpli/resource-collection';
var AdapExpansion = /** @class */ (function (_super) {
    __extends(AdapExpansion, _super);
    function AdapExpansion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sensor = null;
        return _this;
    }
    AdapExpansion.prototype.mounted = function () {
        var _this = this;
        var el = this.$refs.content;
        var elChild = el.childNodes[0];
        this.sensor = new ResizeSensor(elChild, function (_a) {
            var height = _a.height;
            return _this.refreshHeight(height);
        });
    };
    AdapExpansion.prototype.beforeDestroy = function () {
        if (this.sensor) {
            this.sensor.detach();
            this.sensor = null;
        }
    };
    AdapExpansion.prototype.expand = function () {
        return __awaiter(this, void 0, void 0, function () {
            var el;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$await) return [3 /*break*/, 2];
                        // @ts-ignore
                        return [4 /*yield*/, this.$await.run(this.spinner, function () { return _this.collection.expand(); })];
                    case 1:
                        // @ts-ignore
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.collection.expand()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.$emit('expand');
                        if (this.autoScroll) {
                            el = this.$refs.bottom;
                            // @ts-ignore
                            if (this.$scrollTo) {
                                // @ts-ignore
                                this.$scrollTo(el);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AdapExpansion.prototype.refreshHeight = function (height) {
        return __awaiter(this, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        el = this.$refs.content;
                        el.style.height = height + "px";
                        el.style.overflow = 'hidden';
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                    case 1:
                        _a.sent();
                        el.style.overflow = 'unset';
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", ExpansibleCollection)
    ], AdapExpansion.prototype, "collection", void 0);
    __decorate([
        Prop({ type: String, default: 'list' }),
        __metadata("design:type", String)
    ], AdapExpansion.prototype, "spinner", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], AdapExpansion.prototype, "autoScroll", void 0);
    AdapExpansion = __decorate([
        Component({ template: template })
    ], AdapExpansion);
    return AdapExpansion;
}(Vue));
export { AdapExpansion };
//# sourceMappingURL=AdapExpansion.js.map